import React from 'react';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { Box, StackLayout } from '@leagueplatform/genesis-core';
import { SidebarLayout } from '@leagueplatform/genesis-core-alpha';
import { useWalletLanding } from '#pages/wallet-landing/hooks/use-wallet-landing.hook.ts';
import { useMedicalCard } from '#hooks/use-medical-card.hook.ts';
import { WalletCard } from '#components/wallet-card/wallet-card.component.tsx';
import { useMemberCard } from './hooks/use-member-card.hook';
import { CardDetailsTable } from './components/card-details-table.component';
import { MemberDropDown } from '../../../member-dropdown/member-dropdown.component';

export const CardDetails = () => {
  const { cardDetails, showMemberSelect, isLoading } = useMemberCard();
  const { slots } = useWalletLanding();

  const { isMedicalCardEnabled } = useMedicalCard();
  const showBenefitCard =
    !isLoading && isMedicalCardEnabled && cardDetails.length !== 0;

  const PolicyDetails = slots?.PolicyDetails;

  return (
    <SidebarLayout sidebarSide="trailing" spacing="$two">
      <StackLayout spacing="$oneAndHalf">
        {showMemberSelect && <MemberDropDown />}

        {isLoading && <LoadingIndicator inline />}

        {!isLoading && (
          <>
            <CardDetailsTable
              cardDetails={cardDetails}
              hasDependents={showMemberSelect}
            />
            {PolicyDetails ? <PolicyDetails /> : null}
          </>
        )}
      </StackLayout>

      {showBenefitCard && (
        <Box
          css={{
            maxWidth: 320,
            marginX: 'auto',
          }}
        >
          <WalletCard />
        </Box>
      )}
    </SidebarLayout>
  );
};
